import React, {forwardRef} from 'react';
import {a} from '@react-spring/web';
import {useHistory} from 'react-router-dom';
import {BsQuestionLg} from 'react-icons/bs';
import {LuArrowUp, LuArrowDown, LuArrowLeft, LuArrowRight, LuX} from 'react-icons/lu';

import useStore from './useStore';

const Button = forwardRef((props, ref) => {
  const {style = null, tag, modes, currentIcon} = props;
  const set = useStore(s => s.set);
  const modeIndex = useStore(s => s.modeIndex);
  const history = useHistory();

  let elm;
  switch (tag.type) {
    case 'menu':
      const IconMenu = currentIcon;
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center cursor-pointer shine"
          tabIndex={1}
          onClick={() => modes && set({modeIndex: (modeIndex + 1) % modes.length})}
          onKeyUp={e => e.key === 'Enter' && modes && set({modeIndex: (modeIndex + 1) % modes.length})}
        >
          <IconMenu />
        </span>
      );
      break;
    case 'mastertag':
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center cursor-pointer shine"
          tabIndex={1}
          onClick={tag.callback}
          onKeyUp={e => e.key === 'Enter' && tag.callback()}
        >
          {tag.name}
        </span>
      );
      break;
    case 'back':
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center cursor-pointer shine"
          tabIndex={1}
          onClick={tag.callback}
          onKeyUp={e => e.key === 'Enter' && tag.callback()}
        >
          <LuArrowLeft />
        </span>
      );
      break;
    case 'callback':
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center cursor-pointer shine"
          tabIndex={1}
          onClick={tag.callback}
          onKeyUp={e => e.key === 'Enter' && tag.callback()}
        >
          {tag.name}
        </span>
      );
      break;
    case 'disabled':
      elm = <span className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center disabled">{tag.name}</span>;
      break;
    case 'category':
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center disabled"
          style={{...(tag.color && {background: tag.color}), ...(tag.color_text && {color: tag.color_text})}}
        >
          {tag.name}
        </span>
      );
      break;
    case 'link':
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center cursor-pointer shine"
          style={{...(tag.color && {background: tag.color}), ...(tag.color_text && {color: tag.color_text})}}
          tabIndex={1}
          onClick={() => history.push(`${tag.link}1`)}
          onKeyUp={e => e.key === 'Enter' && history.push(`${tag.link}1`)}
        >
          {tag.name}
        </span>
      );
      break;
    case 'infos':
      const IconInfos = tag.open ? LuX : BsQuestionLg;
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center cursor-pointer shine"
          tabIndex={3}
          onClick={tag.callback}
          onKeyUp={e => e.key === 'Enter' && tag.callback()}
        >
          <IconInfos />
        </span>
      );
      break;
    case 'arrow':
      const IconPrev = tag.vertical ? LuArrowUp : LuArrowLeft;
      const IconNext = tag.vertical ? LuArrowDown : LuArrowRight;
      elm = (
        <span
          className="tag tag-colored pt-0.5 pb-0.5 pl-2 pr-2 whitespace-nowrap rounded-custom flex items-center cursor-pointer shine"
          tabIndex={3}
          onClick={tag.callback}
          onKeyUp={e => e.key === 'Enter' && tag.callback()}
        >
          {tag.name === 'prev' && <IconPrev />}
          {tag.name === 'next' && <IconNext />}
        </span>
      );
      break;
    default:
      elm = null;
  }

  return (
    <a.div key={tag.name} ref={ref} className="p-1" style={style}>
      {elm}
    </a.div>
  );
});

export default Button;
